<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }" >
    <nav class="navbar navbar-dark bg-graynav">
      <a class="navbar-brand" href="\">
        <img src="img/brand/enviLogo.png">
      </a>

      <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
          <div class="form-group mb-0">
              <base-input placeholder="Search"
                          class="input-group-alternative"
                          alternative=""
                          addon-right-icon="fas fa-search">
              </base-input>
          </div>
          <ul class="navbar-nav align-right">
            <li class="nav-item">
              <router-link
                to="/"
                class="nav-link"
                href="/"
              >
                  <img src="img/icons/projectIcon/contact_icon.png" title="Contact Us">
              </router-link>
            </li>
          </ul>
          <ul class="navbar-nav align-right">
            <li class="nav-item">
              <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=fQWQf6A-_kawfOBWhicIG2tRAizlK95NhYPBCx0e-KJUNkYyWFFOSkoySzZMRU1XRVpUTEQzVTRBUS4u" target="_blank">
                <img src="img/icons/projectIcon/suggestions_icon.png" title="Suggestions">
              </a>
            </li>
          </ul>
      </form>
    </nav>
    <!-- <side-bar
      :background-color="sidebarBackground"
      short-title="Sydney Metro"
      title="Sydney Metro"
      class="bg-graynav pt-0"
    >
      <template slot="links" v-for="zone in zones">
        <sidebar-item :link="{name: '', title: zone.title, icon: zone.icon, path: zone.path}"/>

      </template>

      <template slot="links">
        <div style="bottom: 7px !important; position:fixed;">
          <sidebar-item :link="{name: '', title: 'Contact Us', icon: 'img/icons/projectIcon/contact_icon.png', path: '/'}"/>
        </div>
      </template>

    </side-bar> -->




    <div class="main-content dark-gray-bg row" :data="sidebarBackground">
      <div class="col-2 pl-0 pr-0" >
        <!-- style="background-color: #d9d9d9;" -->
      <!-- <div class="col-2 pl-0 pr-0" style="background-color: #404952;"> -->
        <!-- <select class="custom-select" name="" v-model="selectedLine" :disabled="lines.length>0?false:true">
          <option value="0" selected disabled>Select Line</option>
          <option v-for="(item, index) in lines" :key="index" :value="item.code">{{item.title}}</option>
        </select> -->
        <!-- <base-button
          size="sm"
          type="dark"
          icon="ni ni-curved-next"
        >
        </base-button> -->
        <dashboard-navbar :menu="computedMenu" :sideBarTitle="computedSideBarTitle"></dashboard-navbar>
      </div>
      <div class="col-10">
        <!-- Content -->
          <tabs fill info type="info" :tabNavClasses="currentSelectedTab.tabs.length<=3? 'tabList col-4' : 'tabList col-10'" tabContentClasses="" :activeTab="currentSelectedTab.tabs[0].code+'Section'">
            <card bodyClasses="frameContainerClass dark-gray-bg">

              <div v-for="(item, itemIndex) in currentSelectedTab.tabs">
                  <tabPane :key="itemIndex" :title="item.title.toUpperCase()" :id="item.code+'Section'">
                    <div class="description">
                      <template v-show="item.url">
                        <vue-friendly-iframe v-if="activeTabFlags[item.code+'Section']" :src="item.url" className="myFrame" allow="*"></vue-friendly-iframe>
                        <!-- <template v-if="item.title == 'INVENTORY'">
                          <vue-friendly-iframe :src="item.url" className="myFrame" allow="*"></vue-friendly-iframe>
                        </template>
                        <template v-else>
                          <img :src="item.url" alt="" class="myFrame">
                        </template> -->
                        <!-- <img src="img/assets/tabs/InsightTab2.png" alt="" class="myFrame"> -->

                        <!-- <vue-friendly-iframe v-if="activeTabFlags[item.title.toLowerCase()+'Section']" :src="item.url" className="myFrame" allow="*"></vue-friendly-iframe> -->
                      </template>

                    </div>
                  </tabPane>
              </div>
              <tabPane key="8" title="TEST">
                <div class="description">
                  <vue-friendly-iframe  src="https://au1gis.solutions.arcadis.com/arcgis/apps/opsdashboard/index.html#/9a0b001a72174faa86d8285e6cd74e82" className="myFrame" allow="*"></vue-friendly-iframe>
                </div>
              </tabPane>
            </card>
          </tabs>
        <!-- router purposes -->
        <div @click="toggleSidebar">
          <fade-transition :duration="200" origin="center top" mode="out-in">
            <router-view></router-view>
          </fade-transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';
  import tabs from '../components/Tabs/Tabs.vue';
  import tabPane from  '../components/Tabs/TabPane.vue';

  export default {
    name: "DashboardLayout",
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition,
      tabs,
      tabPane
    },
    data() {
      return {
        sidebarBackground: 'vue', //vue|blue|orange|green|red|primary
        collapsed: false,
        selectedTheme: '',
        selectedLine: "0",
        computedSideBarTitle: "Project Site"
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      }
    },
    computed: {
      activeTabFlags: {
        get() {
          return this.$store.state.sideBarStore.activeTabFlags
        }
      },
      currentSelectedTab: {
        get() {
          return this.$store.state.sideBarStore.currentSelectedTab
          // return this.$store.state.sideBarStore.currentSelectedCategory
        }
      },
      computedMenu: {
        get() {
          const current = this
          let headerTitle = ""
          var href = ""
          var currentCategory = current.$store.state.sideBarStore.currentSelectedCategory.title
          var currentSelectedSubCategory = current.$store.state.sideBarStore.currentSelectedSubCategory
          var constructedMenu = []

          current.$store.state.sideBarStore.categories.forEach((category, categoryIndex)=>{
            var parentClass = "parentElementStyle"
            if(currentCategory == category.title){
              parentClass = "parentElementStyle text-active-color"
            }
            let elementObject = {
              href: "",
              title: category.title,
              // icon: category.icon,
              // child: [],
              class: parentClass
            }
            // console.log("category.title");
            // console.log(category.title);
              var subCategories =   current.$store.state.sideBarStore.subCategories[category.code]
              // subCategories.forEach((subCategory, subCategoryIndex)=>{
              //   var classValue = 'childElementStyle'
              //   if(currentSelectedSubCategory == subCategory.title){
              //     classValue = 'childElementStyle text-active-color'
              //   }
              //   let childObject = {
              //     href: "/test",
              //     title: subCategory.title,
              //     external: true,
              //     class: classValue
              //   }
              //   elementObject.child.push(childObject)
              // })
              constructedMenu.push(elementObject)
          })
          return constructedMenu
        }
      }
    },
    beforeMount() {
      const current = this
      var currentCategoryCode = current.$store.state.sideBarStore.categories.filter(obj=>obj.code == "cherry_tree")[0];
      current.$store.commit("sideBarStore/setCurrentSelectedCategory",currentCategoryCode)
      console.log("setCurrentSelectedCategory done");
      current.$store.commit("sideBarStore/setCurrentSelectedTab",currentCategoryCode)
      current.$store.commit("sideBarStore/setActiveTabFlags", currentCategoryCode.tabs[0].code+"Section")
      console.log("test current");
    }
  };
</script>
<style>
.navbar-vertical.navbar-expand-md {
  /* position: relative !important;
  height: 90.6vh;
  max-width: 110px !important; */
  max-width: 110px !important;
  top: inherit !important;
  height: 100% !important;
  bottom: unset !important;
  /* z-index: -1; */
}
.childElementStyle {
  color: #fff!important;
  font-weight: bold!important;
}
.parentElementStyle {
  font-weight: bold!important;
}
.headerElementStyle {
  font-weight: bolder!important;
  font-size: 20px!important;
}
.myFrame {
  /* width: 1465px!important; */
  width: 1556px!important;
  /* width: 100% !important; */
  /* height: 763px!important; */
  height: 82vh!important;
  /* border: none; */
}
.frameContainerClass {
  /* padding:3px!important; */
  padding:0px!important;
  /* border-color: #404952; */
  /* border-style: solid; */
  background-color: #222222;
}

</style>
